import { useEffect, useState } from "react";

import InterviewQuestionList from "./InterviewQuestionList";
import { Dialog } from "primereact/dialog";

import { Card } from "primereact/card";
import InterviewQuestionCreate from "./InterviewQuestionCreate";
import { IInterviewQuestion } from "./InterviewQuestion.model";
import { interviewQuestionService } from "../../service/InterviewQuestion/interviewQuestion.service";

const InterviewQuestion = () => {
  const [questionDialog, setQuestionDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IInterviewQuestion[]>([]);
  const openNew = () => {
    setQuestionDialog(true);
  };

  const hideDialog = () => {
    setQuestionDialog(false);
  };

  useEffect(() => {
    loadInterviewQuestions();
  }, []);

  const loadInterviewQuestions = async () => {
    setLoading(true);
    const res = await interviewQuestionService.getAll();
    const sortedData = [...res.data].sort((a, b) => b.id - a.id);
    setData(sortedData);
    setLoading(false);
  };

  return (
    <>
      <Card>
        <Dialog
          visible={questionDialog}
          header={"Interview Question Details"}
          modal
          onHide={() => hideDialog()}
          style={{ width: "70vw" }}>
          <InterviewQuestionCreate
            setQuestionDialog={setQuestionDialog}
            loadInterviewQuestions={loadInterviewQuestions}
          />
        </Dialog>
        <InterviewQuestionList
          openNew={openNew}
          loading={loading}
          data={data}
          loadInterviewQuestions={loadInterviewQuestions}
        />
      </Card>
    </>
  );
};

export default InterviewQuestion;
